{
  "accountTitle": "अकाउंट शीर्षक",
  "accountWalletName": "अकाउंट / वॉलेट नाम",
  "approvedBalance": "स्वीकृत बैलेंस",
  "approvedRewards": "स्वीकृत रिवॉर्ड",
  "availableBalance": "उपलब्ध बैलेंस",
  "balance": "बैलेंस",
  "bank": "बैंक",
  "bnbWallet": "BNB वॉलेट",
  "buyBnbUsdt": "BNB / USDT खरीदें",
  "buyBnbUsdtText": "अपने वॉलेट को फंड करने के लिए सीधे BNB या USDT खरीदें।",
  "buyCryptoSubtitle": "सुरक्षित रूप से क्रिप्टो खरीदें और अपना EXALT वॉलेट फंड करें।",
  "buyExaltCoin": "EXALT कॉइन खरीदें",
  "buyExaltOnPancake": "PancakeSwap पर EXALT खरीदें",
  "connectedWallet": "कनेक्टेड वॉलेट",
  "copied": "कॉपी हो गया",
  "copyAddress": "पता कॉपी करें",
  "copyContract": "कॉन्ट्रैक्ट कॉपी करें",
  "copyExaltContract": "EXALT कॉन्ट्रैक्ट पता कॉपी करें",
  "copyFailed": "कॉपी नहीं हो सकी",
  "copyIban": "IBAN कॉपी करें",
  "copyNumber": "नंबर कॉपी करें",
  "deposit": "Deposit",
  "depositAddress": "डिपॉज़िट पता",
  "depositFailed": "डिपॉज़िट असफल रहा",
  "depositRequest": "डिपॉज़िट अनुरोध",
  "depositRequiredFields": "नाम, अकाउंट/वॉलेट और राशि आवश्यक है",
  "depositSubmittedSuccessfully": "डिपॉज़िट अनुरोध सफलतापूर्वक जमा हो गया",
  "estimatedExchangeWalletValue": "अनुमानित एक्सचेंज वॉलेट मूल्य",
  "exaltContractCopied": "EXALT कॉन्ट्रैक्ट पता कॉपी हो गया।",
  "exaltWallet": "EXALT वॉलेट",
  "fakeSupportReminder": "नकली सहायता एजेंटों से सावधान रहें। Exalt Exchange स्टाफ कभी भी आपका पासवर्ड या प्राइवेट की नहीं मांगेगा।",
  "loadingWallet": "वॉलेट लोड हो रहा है...",
  "lockedBalance": "लॉक्ड बैलेंस",
  "pendingRewards": "लंबित रिवॉर्ड",
  "readyTradingWithdrawal": "ट्रेडिंग या विड्रॉल के लिए तैयार",
  "refreshBalance": "बैलेंस रिफ्रेश करें",
  "securityAdminApproval": "वॉलेट क्रेडिट से पहले एडमिन स्वीकृति आवश्यक है",
  "securityBackendApproval": "सभी डिपॉज़िट और विड्रॉल रिकॉर्ड बैकएंड स्वीकृति द्वारा सुरक्षित हैं",
  "securityLicensedGateways": "बैंक/कार्ड भुगतान केवल लाइसेंस प्राप्त गेटवे से जुड़े हैं",
  "securityNoAutoRelease": "सत्यापन के बिना स्वचालित टोकन जारी नहीं होंगे",
  "securityReminder": "सुरक्षा अनुस्मारक",
  "securitySystem": "सुरक्षा प्रणाली",
  "securityWalletVerification": "उपयोगकर्ता वॉलेट सत्यापन आवश्यक है",
  "sellSwapBack": "बेचें / वापस स्वैप करें",
  "sellSwapBackText": "अपने EXALT को किसी भी समय BNB या USDT में वापस स्वैप करें।",
  "serverError": "सर्वर त्रुटि।",
  "sessionExpired": "सत्र समाप्त हो गया। कृपया पुनः लॉगिन करें।",
  "step1": "चरण 1",
  "step2": "चरण 2",
  "step3": "चरण 3",
  "submitDeposit": "डिपॉज़िट जमा करें",
  "submitWithdrawal": "विड्रॉल जमा करें",
  "swapToExaltText": "अपने BNB या USDT को EXALT में स्वैप करें।",
  "totalAssets": "कुल संपत्ति",
  "totalPortfolioValue": "कुल पोर्टफोलियो मूल्य",
  "transactionHashReference": "ट्रांज़ैक्शन हैश / रेफरेंस आईडी",
  "transfer": "स्थानांतरण",
  "usdtWallet": "USDT वॉलेट",
  "useBscReminder": "हमेशा BNB स्मार्ट चेन (BEP-20) नेटवर्क का उपयोग करें।",
  "verifyContractReminder": "ट्रेडिंग से पहले हमेशा आधिकारिक कॉन्ट्रैक्ट पते की पुष्टि करें।",
  "waitingAdminApproval": "एडमिन स्वीकृति की प्रतीक्षा",
  "wallet": "वॉलेट",
  "walletAddress": "वॉलेट एड्रेस",
  "walletBankIbanPlaceholder": "वॉलेट पता / JazzCash / EasyPaisa / बैंक अकाउंट / IBAN",
  "walletNotConnected": "वॉलेट कनेक्ट नहीं है",
  "walletStatus": "वॉलेट स्थिति",
  "walletsSubtitle": "अपने क्रिप्टो वॉलेट, डिपॉज़िट, विड्रॉल और भुगतान अनुरोधों का प्रबंधन करें।",
  "walletsTitle": "वॉलेट्स",
  "withdraw": "निकालें",
  "withdrawRequiredFields": "राशि, अकाउंट नाम और वॉलेट/अकाउंट नंबर आवश्यक है",
  "withdrawalFailed": "विड्रॉल असफल रहा",
  "withdrawalRequest": "विड्रॉल अनुरोध",
  "withdrawalSubmittedSuccessfully": "विड्रॉल अनुरोध सफलतापूर्वक जमा हो गया",
  "yourName": "आपका नाम"
}